import * as Colors from '@brightlayer-ui/colors';
import { Tab, Tabs } from '@mui/material';
import React from 'react';
import { TabsComponentProps } from './types';

const TabsComponent: React.FC<TabsComponentProps> = ({ value, onChange, labels }) => (
    <Tabs
        value={value}
        onChange={onChange}
        TabIndicatorProps={{ sx: { backgroundColor: Colors.blue[500] } }}
        textColor="inherit"
    >
        {labels.map((label, index) => (
            <Tab
                data-testid={`${label}-admin-dashboard-tabs`}
                key={index}
                sx={{
                    color: value === index ? Colors.blue[500] : Colors.gray[900],
                    textTransform: 'none',
                }}
                label={label}
            />
        ))}
    </Tabs>
);

export default TabsComponent;
